<template>
  <header class="site-header">
    <div class="container header-inner">
      <router-link to="/" class="logo">
        <span class="logo-mark">万</span>
        <span class="logo-text">
          <strong>{{ t('brand.name') }}</strong>
          <small>{{ t('brand.subtitle') }}</small>
        </span>
      </router-link>

      <button class="menu-toggle" @click="menuOpen = !menuOpen" :aria-label="t('nav.menu')">
        <span></span><span></span><span></span>
      </button>

      <nav :class="['nav', { open: menuOpen }]">
        <router-link to="/" @click="menuOpen = false">{{ t('nav.home') }}</router-link>
        <router-link to="/services" @click="menuOpen = false">{{ t('nav.services') }}</router-link>
        <router-link to="/projects" @click="menuOpen = false">{{ t('nav.projects') }}</router-link>
        <router-link to="/news" @click="menuOpen = false">{{ t('nav.news') }}</router-link>
        <router-link to="/contact" @click="menuOpen = false">{{ t('nav.contact') }}</router-link>
        <div class="nav-lang">
          <LanguageSwitcher />
        </div>
      </nav>

      <div class="header-actions">
        <LanguageSwitcher />
        <router-link to="/projects" class="btn btn-primary btn-cta">{{ t('nav.bookNow') }}</router-link>
      </div>
    </div>
  </header>
</template>

<script>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import LanguageSwitcher from '../LanguageSwitcher.vue'

export default {
  name: 'AppHeader',
  components: { LanguageSwitcher },
  setup() {
    const { t } = useI18n()
    const menuOpen = ref(false)
    return { t, menuOpen }
  },
}
</script>

<style scoped>
.site-header {
  background: linear-gradient(135deg, var(--color-primary-dark), var(--color-primary));
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 20px rgba(15, 46, 38, 0.22);
}

.header-inner {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  min-height: 72px;
}

.logo {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: #fff;
  flex-shrink: 0;
}

.logo-mark {
  width: 42px;
  height: 42px;
  border-radius: 10px;
  background: var(--color-accent);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 1.1rem;
}

.logo-text {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}

.logo-text strong {
  font-size: 1.05rem;
}

.logo-text small {
  font-size: 0.72rem;
  opacity: 0.75;
}

.nav {
  display: flex;
  align-items: center;
  gap: 1.75rem;
  margin-left: auto;
}

.nav a {
  color: rgba(255, 255, 255, 0.85);
  font-size: 0.95rem;
  font-weight: 500;
  transition: color 0.2s;
}

.nav a:hover,
.nav a.router-link-active {
  color: var(--color-accent);
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  flex-shrink: 0;
}

.nav-lang {
  display: none;
}

.btn-cta {
  flex-shrink: 0;
}

.menu-toggle {
  display: none;
  flex-direction: column;
  gap: 5px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.25rem;
  margin-left: auto;
}

.menu-toggle span {
  display: block;
  width: 22px;
  height: 2px;
  background: #fff;
  border-radius: 2px;
}

@media (max-width: 900px) {
  .menu-toggle {
    display: flex;
  }

  .nav {
    display: none;
    position: absolute;
    top: 72px;
    left: 0;
    right: 0;
    flex-direction: column;
    background: var(--color-primary-dark);
    padding: 1rem 1.25rem 1.5rem;
    gap: 1rem;
    margin-left: 0;
  }

  .nav.open {
    display: flex;
  }

  .nav-lang {
    display: block;
    padding-top: 0.25rem;
  }

  .header-actions {
    display: none;
  }
}
</style>
